export default "__VITE_ASSET__BK$yxjzH__"